export const validateTimings = (obj) => {

    let values = [...Object.values(obj)];

    values.shift();

    let validate = false;
    for (let value of values) {
        if (value.open === true) {
            let d = value.multipleHours.filter(e => e.open && e.description);
            if (d.length) {
                validate = true
            } else {
                validate = false
            }
        }
    }
    return validate;
}